import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-dots-loader',
  templateUrl: './dots-loader.component.html',
  styleUrls: ['./dots-loader.component.scss']
})
export class DotsLoaderComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/a/1/s/Fed/src/app/shared/components/dots-loader/dots-loader.component.ts